module.exports = __webpack_public_path__ + "img/form-icon.023d510f.png";